import { Fragment, useEffect, useState } from "react";
import { adminDoGetListUserInvitations } from "services/admin/list-user-invitation";
import { useList } from "stores/hooks/list";
import { useListUser } from "stores/hooks/list-user";
import EmailHistoryTable from "./table";
import { ListInvitation } from "models/list-invitation";

const ListUserEmailHistoryTab = () => {
  const list = useList();
  const user = useListUser();
  const [invitations, toggleInvitations] = useState<ListInvitation[]>([]);

  const update = async () => {
    if (list && user) {
      const invs = await adminDoGetListUserInvitations(list, user.uuid);
      toggleInvitations(invs);
    }
  };

  useEffect(() => {
    update();
  }, [list, user]);

  if (!user) {
    return null;
  }

  return (
    <Fragment>
      <EmailHistoryTable listInvitations={invitations} />
    </Fragment>
  );
};

export default ListUserEmailHistoryTab;
